var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Silhouettes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245,
    height: 245,
    viewBox: "0 0 245 245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .f1-cls1 {\n        fill: none;\n      }\n\n      .f1-cls2 {\n        fill: #f1ad25;\n      }\n\n      .f1-cls3 {\n        clip-path: url(#f1-clippath-1);\n      }\n\n      .f1-cls4 {\n        clip-path: url(#f1-clippath);\n      }\n\n      .f1-cls5 {\n        fill: #f2ad28;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f1-cls1",
    x: 4.88,
    y: 9.39,
    width: 41.61,
    height: 39.6,
    transform: "translate(-13.18 28.07) rotate(-47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1-clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f1-cls1",
    x: 7.97,
    y: 66.82,
    width: 10.79,
    height: 14.43,
    transform: "translate(-49.9 33.32) rotate(-47)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "F1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_143",
    "data-name": "Groupe 143",
    transform: "translate(5 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f1-cls4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141",
    "data-name": "Groupe 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233",
    "data-name": "Trac\\xE9 233",
    className: "f1-cls5",
    d: "M38.7,12.92c7.55,5.98,7.3,20.47,1.78,28.93-5.66,8.68-16.52,12.68-27.31,4-7.5-6.03-11.93-16.16-5.48-26.06,5.52-8.47,22-14.01,31.01-6.87"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_146",
    "data-name": "Groupe 146",
    transform: "translate(5 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f1-cls3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141-2",
    "data-name": "Groupe 141-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_233-2",
    "data-name": "Trac\\xE9 233-2",
    className: "f1-cls5",
    d: "M16.62,69.71c2.7,2.24,3.38,6.69,2.08,9.01-1.33,2.38-4.55,3.04-8.41-.2-2.68-2.25-4.61-5.61-3.09-8.32,1.3-2.32,6.21-3.16,9.42-.49"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "f1-cls2",
    d: "M139.84,29.18c-29.19.86-62.03,14.3-75.75,29.77s-27.66,33.98-34.42,63.82-6.53,54.89-1.96,71.45,17.43,45.52,44,49.23c26.57,3.7,89.09-3.05,102.38-9.15,13.29-6.1,42.48-22,58.16-59.25,15.68-37.25,10.67-55.76,10.46-63.39-.22-7.62-1.09-26.14-17.21-45.96-16.12-19.82-43.66-37.75-85.65-36.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.72,171.56s0-.01,0-.02c-11.5-11.63-21.25-22.35-23.21-28.1-1.65-4.85-.39-10.67-3.19-15.3l-38.54-4.2c-.26-33.46,12.39-63.1-6.21-93.89-13.73-22.74-37.61-34.34-62.83-20.84-12.19,6.52-24.56,30.26-25.98,43.98-2.6,25.26,17.61,49.19,5.79,75.31l-40.56,11.42c-3.66,9.18-8.52,17.72-13.93,26-.07.32-.18.62-.34.92-.09,1.56-.16,3.1-.21,4.62,0,.04,0,.08,0,.12,0-.02,0-.04,0-.05.32,8.69,1.43,16.34,3.19,22.72,2.36,8.56,6.95,20.43,14.49,30.42,3.16-4.02,6.06-7.4,7.99-9.37.11,6.28.49,12.56.91,18.83,0,0,0,0,0,0,0,0,0,0,0,0,5.7,4.75,12.51,8.22,20.6,9.35,26.57,3.7,89.09-3.05,102.38-9.15s42.48-22,58.16-59.25c.5-1.2.99-2.38,1.45-3.54,0,0,.01.01.02.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.d71fa93bd7fa307cb73c2028fd288864.svg";
export { ForwardRef as ReactComponent };